import { createSlice } from '@reduxjs/toolkit';
import { fetchWaterTestParamsAsync, fetchWaterTestParamsAsyncBuilder } from './asyncRequests'

export interface WaterTestParameter {
  _id: string;
  name: string;
  values: number[];
  measurement: string | null;
  category: string;
  colors: string[];
  allowable_range: number[] | null;
  label?: string;
}

export interface WaterTestParamsState {
  data: WaterTestParameter[]
  loading: boolean;
  success: boolean;
  error: string | null;
}

const initialState: WaterTestParamsState = {
  data: [],
  loading: false,
  success: false,
  error: null,

};

const waterTestParamsSlice = createSlice({
  name: 'waterTestParams',
  initialState,
  reducers: {
    toggleLoading : (state) => {
      state.loading = !state.loading;
    },
    resetForm: () => initialState,
  },
  extraReducers: (builder) => {
    fetchWaterTestParamsAsyncBuilder(builder);
  },
});


export const WaterTestParamsActions = {
  ...waterTestParamsSlice.actions,
  fetchWaterTestParamsAsync,

};
export const WaterTestParamsReducer =waterTestParamsSlice.reducer;